import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { authFetch } from "../../lib/api"

const STATUS_CLASS = {
  pending: "dashboard-badge--pending",
  confirmed: "dashboard-badge--confirmed",
  cancelled: "dashboard-badge--cancelled",
  completed: "dashboard-badge--completed",
}

function formatDate(d) {
  if (!d) return "Any date"
  return new Date(d).toLocaleDateString(undefined, { dateStyle: "medium" })
}

export default function Bookings() {
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  const load = () => {
    setError("")
    authFetch("/api/bookings")
      .then((r) => r.json())
      .then((data) => {
        if (data.error) setError(data.error)
        else setList(data.bookings || [])
      })
      .catch(() => setError("Failed to load bookings"))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    load()
  }, [])

  const handleCancel = async (id) => {
    if (!window.confirm("Cancel this booking?")) return
    const res = await authFetch(`/api/bookings/${id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status: "cancelled" }),
    })
    if (res.ok) load()
    else {
      const data = await res.json()
      alert(data.error || "Could not cancel")
    }
  }

  return (
    <section className='dashboard-card'>
      <div className='dashboard-card__header'>
        <div>
          <span className='dashboard-eyebrow'>Tours and stays</span>
          <h2>Bookings</h2>
          <p>Pending or confirmed bookings can be cancelled from here.</p>
        </div>
        <Link to='/listings' className='dashboard-primary-action'>
          <i className='fa-solid fa-calendar-plus'></i>
          Book a property
        </Link>
      </div>

      {error && <p className='dashboard-error'>{error}</p>}
      {loading ? (
        <p>Loading...</p>
      ) : list.length === 0 ? (
        <div className='dashboard-empty'>No bookings yet.</div>
      ) : (
        <ul className='dashboard-list'>
          {list.map((item) => (
            <li key={item.id} className='dashboard-list__row'>
              <div>
                {item.listing ? (
                  <Link to={`/listings/${item.listingId}`}>{item.listing.name}</Link>
                ) : (
                  <strong>Listing {item.listingId}</strong>
                )}
                <div className='dashboard-list__meta'>
                  {formatDate(item.startDate)} - {formatDate(item.endDate)} / {item.type}
                  {item.totalPrice != null && ` / $${item.totalPrice}`}
                </div>
                <span className={`dashboard-badge ${STATUS_CLASS[item.status] || ""}`}>
                  {item.status}
                </span>
              </div>
              <div className='dashboard-list__actions'>
                <Link to={`/listings/${item.listingId}`} className='btn btn--secondary'>
                  View listing
                </Link>
                {(item.status === "pending" || item.status === "confirmed") && (
                  <button type='button' className='btn btn--danger' onClick={() => handleCancel(item.id)}>
                    Cancel
                  </button>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
